import { render, staticRenderFns } from "./content-details.vue?vue&type=template&id=33f0da5e&scoped=true"
import script from "./content-details.vue?vue&type=script&lang=js"
export * from "./content-details.vue?vue&type=script&lang=js"
import style0 from "./content-details.vue?vue&type=style&index=0&id=33f0da5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f0da5e",
  null
  
)

export default component.exports